import React from "react";
import { TimeSlot } from "../../api/scheduleApi.ts";
import TimeslotForm from "./TimeslotForm.tsx";
import TimeslotList from "./TimeslotList.tsx";
import { LocationWithName } from "../../api/locationApi.ts";
import InfoBox from "../util/InfoBox.tsx";
import { Trans } from "@lingui/react/macro";

interface TimeslotFormProps {
  onAddTimeslot: (newTimeSlot: TimeSlot) => void;
  onDeleteTimeslot: (updateLocationId: string, id: string) => void;
  existingTimeslots: TimeSlot[];
  isLoading: boolean;
  deletingId: string | null;
  onSelectLocation: (location: LocationWithName) => void;
  selectedLocation: LocationWithName;
  locations: LocationWithName[];
}

const TimeslotSettings: React.FC<TimeslotFormProps> = ({
  onAddTimeslot,
  onDeleteTimeslot,
  existingTimeslots,
  isLoading,
  deletingId,
  onSelectLocation,
  selectedLocation,
  locations,
}) => {
  return (
    <>
      <InfoBox variant={"info"} className={"mb-4"}>
        <Trans>
          This is your regular weekly schedule. Create time slots for your
          normal teaching times.
        </Trans>
      </InfoBox>
      <TimeslotForm
        onAddTimeslot={onAddTimeslot}
        existingTimeslots={existingTimeslots}
        isLoading={isLoading}
        locations={locations}
        onSelectLocation={onSelectLocation}
        selectedLocation={selectedLocation}
      />
      <TimeslotList
        timeslots={existingTimeslots}
        onDeleteTimeslot={onDeleteTimeslot}
        deletingId={deletingId}
        locations={locations}
      />
    </>
  );
};

export default TimeslotSettings;
